import "./App.css";
import Vorwort from "./Vorwort";
import NPVCalculator from "./NPVCalculator";

function App() {
  return (
    <>
      <Vorwort />
      <NPVCalculator />
    </>
  );
}

export default App;
